import { Injectable } from '@angular/core';
import { MenuItemGroup } from '@app/interfaces';
import { MenuService } from '@app/services/menu/menu.service';

// This is a duplicate menu service to maintain links to documents-v2 components.
// It can be removed or updated as the urls we serve documents-v2 from changes.

const DocumentsMenu: MenuItemGroup = [
    {
        key: 'account.menu.myDocs',
        link: ['/profile', 'documents-v2'],
        routerLinkExact: true,
    },
    {
        key: 'account.menu.publicDocs',
        link: ['/profile', 'documents-v2', 'public'],
        routerLinkExact: true,
    },
];

@Injectable()
export class DocumentsV2MenuService extends MenuService {
    setBaseMenu(): void {
        this.baseMenu = DocumentsMenu;
    }
}
